export default "__VITE_ASSET__19e360fd__"